import React, { useEffect, useState } from "react";
import "./css/category.css";
import add from "./../../../assets/Icon/add.svg";
// import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import eye from "./../../../assets/Icon/eye.svg";
import { InputGroup } from "react-bootstrap";
import RequiredLabel from "../../CustomCommons/RequiredLabel";
import SelectDropDown from "../../CustomCommons/SelectDropDown";
import axios from "axios";
import { BASE_URL } from "../../Const/Url";
import { handleInputs } from "../../../utils/HandleInputs";
import { showToast } from "../../../utils/ToastHelper";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import * as path from "../../Routes/RoutePaths";
import { can_add_category, has_permissions } from "../../CustomCommons/utils";
import Permission from "../../CustomCommons/Permission";
import { logout_func3 } from "../../Const/logoutCommon";
import SelectDropDown2 from "../../CustomCommons/SelectDropDown2";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Editor from "../../Promotion/Blogs/Editor";
import AltTextUpdater from "../../CustomCommons/AltTextUpdater";
import { indexingStatus as indexingStatusOptions } from "../../CustomCommons/status";
const animatedComponents = makeAnimated();
const AddCategory = () => {
  const history = useHistory();
  const [categoryList, setcategoryList] = useState([]);
  const [categoryListCombo, setcategoryListCombo] = useState([]);
  const [inputQuery, setInputQuery] = useState("");
  const [otherOption, setOtherOption] = useState(true);
  const [categoryAllData, setcategoryAllData] = useState({
    category_name: "",
    category_description: "",
    lebel: 0,
    cat_order: 1,
    meta_title: "",
    meta_desc: "",
  });
  const [Categoryswitch, setCategoryswitch] = useState(true);
  const [mediaType, setMediaType] = useState(0); // 0 = image, 1 = video
  const [Thumb, setThumb] = useState(null);
  const [thumbId, setThumbId] = useState(null);
  const [videoId, setVideoId] = useState(null);
  const [videoName, setVideoName] = useState("");
  const [videoPreview, setVideoPreview] = useState("");
  const [selectedOptionCategory, setSelectedOptionCategory] = useState(null);
  const [metaTags, setMetaTegs] = useState(null);
  const handleMetaTags = (newValue, actionMeta) => {
    setMetaTegs(newValue);
  };
  const [isNew, setIsNew] = useState(false);
  const [realatedCombo, setRealatedCombo] = useState([]);
  const [mainCategory, setMainCategory] = useState([
    { value: "0", label: "Home Decor" },
  ]);
  const [subCategory, setSubCategory] = useState(null);
  const [subMainCategoryType, setsubMainCategoryType] = useState([
    {
      value: "1",
      label: "Sub Main Category",
    },
  ]);

  useEffect(() => {
    setOtherOption(!otherOption);
  }, [subMainCategoryType]);
  console.log(subMainCategoryType, "smc");
  const [fileName, setFileName] = useState("");
  const [URL, setURL] = useState("");
  const [imageAltText, setImageAltText] = useState("");
  const [videoAltText, setVideoAltText] = useState("");
  const [slug, setSlug] = useState("");
  const [canonicalUrl, setCanonicalUrl] = useState("");
  const [indexingStatus, setIndexingStatus] = useState("index");
  const [setSchema, setSetSchema] = useState("");

  const uploadDocument = (file, onSuccess, docType = 0, altText = "") => {
    if (!file) return;
    const formData = new FormData();
    formData.append("document", file);
    formData.append("doc_type", docType);
    // Append alt_text if provided (for image uploads)
    if (altText && altText.trim() !== "") {
      formData.append("alt_text", altText.trim());
    }

    axios
      .post(`${BASE_URL}api/v1/auth/documents/upload/`, formData)
      .then((res) => {
        if (res?.data?.status) {
          onSuccess(res?.data?.data?.id);
          showToast("success", "File uploaded successfully");
        } else {
          showToast("error", "Failed to upload file");
        }
      })
      .catch((err) => {
        const message =
          err?.response?.data?.errors?.document?.[0] ||
          err?.response?.data?.message ||
          "Upload failed";
        showToast("error", message);
      });
  };

  const fileHandle = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setThumb(file);
    uploadDocument(
      file,
      (id) => {
        setThumbId(id);
        setFileName(file.name);
        const reader = new FileReader();
        reader.onload = () => setURL(reader.result);
        reader.readAsDataURL(file);
      },
      0,
      imageAltText // Pass alt_text when uploading image
    );
  };

  const handleVideoUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    uploadDocument(
      file,
      (id) => {
        setVideoId(id);
        setVideoName(file.name);
        const reader = new FileReader();
        reader.onload = () => setVideoPreview(reader.result);
        reader.readAsDataURL(file);
      },
      1
    );
  };

  const resetMedia = () => {
    setThumbId(null);
    setThumb(null);
    setFileName("");
    setURL("");
    setVideoId(null);
    setVideoName("");
    setVideoPreview("");
    setImageAltText(""); // Reset alt_text when media is reset
  };
  const removeImg = () => {
    swal({
      title: "Are you sure?",
      text: "Once Removed, you will not be able to recover this  file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setURL("");
        setFileName("");
        swal("Poof! Your  file has been Removed!", {
          icon: "success",
        });
        setThumb(null);
        setThumbId(null);
      } else {
        swal("Your  file is safe!");
      }
    });
  };

  const removeVideo = () => {
    swal({
      title: "Are you sure?",
      text: "Once Removed, you will not be able to recover this  file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setVideoPreview("");
        setVideoName("");
        swal("Poof! Your  file has been Removed!", {
          icon: "success",
        });
        setVideoId(null);
      } else {
        swal("Your  file is safe!");
      }
    });
  };

  const clearData = () => {
    setThumb(null);
    setcategoryAllData({
      category_name: "",
      category_description: "",
      lebel: 0,
      meta_title: "",
      meta_desc: "",
    });
    setThumbId(null);
    setURL("");
    setFileName("");
    setVideoId(null);
    setVideoName("");
    setVideoPreview("");
    setSelectedOptionCategory(null);
    setMediaType(0);
    setSlug("");
    setCanonicalUrl("");
    setIndexingStatus("index");
    setSetSchema("");
    setImageAltText("");
  };

  const toggleSwitch = () => {
    setCategoryswitch((current) => !current);
  };

  const getCategory = () => {
    const url = `${BASE_URL}api/v1/inventory/inventory/category/?limit=50&category_type=1&main_category=${
      Array.isArray(mainCategory) === true
        ? mainCategory[0]?.value
        : mainCategory?.value
    }`;
    axios
      .get(url)
      .then((res) => {
        console.log(res.data.data.results);
        const result = res.data.data.results;
        const options = result.map((curr) => ({
          label: curr.name,
          value: curr.id,
        }));
        setcategoryList(options);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        console.log(err.request.response);
      });
  };
  const getCategory2 = () => {
    const url = `${BASE_URL}api/v1/inventory/inventory/category/?limit=50&category_type=2&main_category=${
      Array.isArray(mainCategory) === true
        ? mainCategory[0]?.value
        : mainCategory?.value
    }&query=${inputQuery}`;
    axios
      .get(url)
      .then((res) => {
        console.log(res.data.data.results);
        const result = res.data.data.results;
        const options = result.map((curr) => ({
          label: curr.name,
          value: curr.id,
        }));
        setcategoryListCombo(options);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        console.log(err.request.response);
      });
  };
  const PostCategory = () => {
    const url = `${BASE_URL}api/v1/inventory/inventory/category/`;
    const data = new FormData();
    data.append("name", categoryAllData["category_name"]);
    data.append("description", categoryAllData["category_description"]);
    data.append("lebel", 1);
    data.append("is_combo_category", isNew);
    // Send image or video based on mediaType, but not media_type itself
    if (Number(mediaType) === 0 && thumbId) {
      data.append("thumb", thumbId);
    }
    if (Number(mediaType) === 1 && videoId) {
      data.append("video", videoId);
    }

    if (
      selectedOptionCategory !== null &&
      selectedOptionCategory !== undefined &&
      selectedOptionCategory.value !== null &&
      selectedOptionCategory.value !== undefined &&
      typeof selectedOptionCategory.value !== "string"
    ) {
      data.append("parent_name", selectedOptionCategory.value);
    }
    if (mainCategory !== null && mainCategory !== undefined) {
      data.append(
        "main_category",
        Array.isArray(mainCategory) === true
          ? mainCategory[0]?.value
          : mainCategory?.value
      );
    }
    if (
      (subCategory !== null &&
        subCategory !== undefined &&
        subCategory.value !== null &&
        subCategory.value !== undefined) ||
      otherOption === true
    ) {
      data.append(
        "sub_main_category",
        Array.isArray(subCategory) === true
          ? subCategory[0]?.value
          : subCategory?.value
      );
    }

    data.append(
      "category_type",
      Array.isArray(subMainCategoryType) === true
        ? subMainCategoryType[0]?.value
        : subMainCategoryType?.value
    );

    data.append("order", categoryAllData?.cat_order);
    data.append("is_active", Categoryswitch);
    if (data.name === "") {
      showToast("error", "Category name can't be empty..");
      return 0;
    } else if (data.description === "") {
      showToast("error", "Category description can't be empty..");
      return 0;
    }
    if (metaTags?.length > 0) {
      data.append(
        "meta_tags",
        JSON.stringify(metaTags?.map((obj) => ({ name: obj.label })))
      );
    }
    if (realatedCombo?.length > 0) {
      data.append(
        "combo_connected_category",
        realatedCombo.map((item) => item.value)
      );
    }
    // if (realatedCombo?.length > 0) {
    //   data.append(
    //     "combo_connected_category",
    //     JSON.stringify(realatedCombo.map(item => item.value))
    //   );
    // }
    data.append("meta_title", categoryAllData.meta_title);
    data.append("meta_description", categoryAllData.meta_desc);
    
    // Add SEO fields
    const trimmedSlug = slug.trim();
    if (trimmedSlug.length > 0) {
      data.append("slug", trimmedSlug);
      data.append("is_custom_slug", true);
    } else {
      data.append("is_custom_slug", false);
    }
    if (canonicalUrl.trim()) {
      data.append("canonical_url", canonicalUrl.trim());
    }
    data.append("indexing", indexingStatus);
    if (setSchema.trim()) {
      data.append("set_schema", setSchema.trim());
    }
    
    axios
      .post(url, data)
      .then((res) => {
        if (res.data.status) {
          clearData();
          showToast("success", "Category Added.");
          history.push(path.category_list);
        }
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        const errorMsg = JSON.parse(err.request.response).errors;
        console.log(errorMsg);
        for (let key in errorMsg) {
          showToast("error", `${key} : ${errorMsg[key][0]}`);
        }
        showToast("error", message);
        if (
          message === "Invalid token." ||
          JSON.parse(err?.request?.response)?.code === 401
        ) {
          logout_func3(history);
        }
      });
  };

  useEffect(() => {
    getCategory();
  }, [mainCategory, subMainCategoryType]);
  useEffect(() => {
    getCategory2();
  }, [inputQuery, mainCategory, subMainCategoryType]);

  const handleCancelButton = () => {
    history.push(path.category_list);
  };

  if (!has_permissions(can_add_category) && !has_permissions('Can add blogcategory')) {
    return <Permission />;
  }
  const mainCategorySelect = [
    { value: "0", label: "Home Decor" },
    { value: "1", label: "In Style" },
  ];
  const subMainCategoryTypeSelect = [
    { value: "1", label: "Sub Main Category" },
    { value: "2", label: "Others Category" },
  ];
  const reletedCombo = (newValue) => {
    setRealatedCombo(newValue);
  };
  const inputProduct = (inputValue) => {
    setInputQuery(inputValue);
  };
  return (
    <div className="categorey-parent new-categorey-parent an">
      <div className="bg-white  add-div">
        <div
          className="d-flex align-items-center"
          style={{ padding: "20px 35px ", border: "0.5px solid #E0E0E0" }}
        >
          <h3 style={{ fontSize: "23px", marginTop: "6px" }}>
            Add New Category
          </h3>
        </div>
        {/* --------------category form--------- */}
        <div
          style={{
            padding: "20px 35px ",
            borderBottom: " 0.5px solid #E0E0E0",
            borderRight: " 0.5px solid #E0E0E0",
            borderLeft: "0.5px solid #E0E0E0",
          }}
        >
          {/* -----------name-------------- */}
          <RequiredLabel text={"Name"} />
          <InputGroup className="mb-3">
            <Form.Control
              aria-label="Username"
              aria-describedby="basic-addon1"
              style={{ backgroundColor: "#FAFAFA" }}
              placeholder="Type Name"
              name="category_name"
              value={categoryAllData["category_name"]}
              onChange={(e) => handleInputs(e, setcategoryAllData)}
            />
          </InputGroup>
          {/* main Category */}
          <RequiredLabel text={"Main Category"} />
          <div className="mb-3" style={{ backgroundColor: "#FAFAFA" }}>
            <SelectDropDown2
              options={mainCategorySelect}
              setSelectedOptionCategory={setMainCategory}
              deafaultV={mainCategory}
            />
          </div>
          <RequiredLabel text={" Category Type"} />
          <div className="mb-3" style={{ backgroundColor: "#FAFAFA" }}>
            <SelectDropDown2
              options={subMainCategoryTypeSelect}
              setSelectedOptionCategory={setsubMainCategoryType}
              deafaultV={subMainCategoryType}
            />
          </div>
          {/* Sub Category */}
          {otherOption === true ? (
            <>
              <RequiredLabel text={"Sub Category"} />
              <div className="mb-3" style={{ backgroundColor: "#FAFAFA" }}>
                <SelectDropDown
                  options={categoryList}
                  setSelectedOptionCategory={setSubCategory}
                />
              </div>
            </>
          ) : (
            <></>
          )}

          <div className="row">
            <div className="col-12 col-md-6">
              <RequiredLabel text={"category Order"} />
              <InputGroup className="mb-3" style={{ height: "47px" }}>
                <Form.Control
                  type="number"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                  min={1}
                  name="cat_order"
                  value={categoryAllData["cat_order"]}
                  onChange={(e) => handleInputs(e, setcategoryAllData)}
                />
              </InputGroup>
            </div>
            <div className="col-12 col-md-6">
              <RequiredLabel text={"Is Combo Category"} />
              <InputGroup className="mb-3">
                <Form.Check // prettier-ignore
                  type="switch"
                  id="custom-switch"
                  label={`${isNew ? "Yes" : "No"}`}
                  checked={isNew === true}
                  onChange={() => setIsNew(!isNew)}
                />
              </InputGroup>
            </div>
            {/* {otherOption === true && isNew === true ? (
              <>
                <div className="col-12 col-md-12">
                  <p>Realated Combo Category</p>
                  <div className="mb-3" style={{ backgroundColor: "#FAFAFA" }}>
                    <Select
                      isMulti
                      placeholder="---Select---"
                      isClearable
                      onChange={reletedCombo}
                      options={categoryListCombo}
                      onInputChange={inputProduct}
                    />
                  </div>
                </div>
              </>
            ) : (
              <></>
            )} */}
          </div>

          {/* <RequiredLabel text={""} /> */}

          <p>Long Description</p>
          <div className="mb-3">
            <Editor
              content={categoryAllData["category_description"] || ""}
              setContent={(newContent) => {
                setcategoryAllData((prev) => ({
                  ...prev,
                  category_description: newContent,
                }));
              }}
            />
          </div>
          {/* --------img----------- */}

          <div className="col-12 mb-3 ">
            {/* <RequiredLabel text={"Meta Tags"} /> */}
            <p>Meta Tags</p>
            <div>
              <CreatableSelect
                isMulti
                placeholder="Enter Value"
                onChange={handleMetaTags}
                value={metaTags}
                defaultValue={metaTags}
                // components={animatedComponents}
              />
            </div>
          </div>
          <div className="col-12 mb-3 ">
            {/* <RequiredLabel text={"Meta Tags"} /> */}
            <p>Meta Description</p>
            <InputGroup className="mb-3">
              <Form.Control
                as={"textarea"}
                aria-label="Username"
                name="meta_desc"
                value={categoryAllData["meta_desc"]}
                onChange={(e) => handleInputs(e, setcategoryAllData)}
                aria-describedby="basic-addon1"
                style={{
                  height: "100px",
                  resize: "none",
                  backgroundColor: "#FAFAFA",
                }}
              />
            </InputGroup>
          </div>

          {/* Meta Title */}
          <div className="col-12 mb-3 ">
            <p>Meta Title</p>
            <InputGroup className="mb-3" style={{ height: "47px" }}>
              <Form.Control
                aria-label="Meta Title"
                name="meta_title"
                value={categoryAllData["meta_title"]}
                onChange={(e) => handleInputs(e, setcategoryAllData)}
                aria-describedby="basic-addon1"
                style={{ backgroundColor: "#FAFAFA" }}
              />
            </InputGroup>
          </div>

          {/* SEO Fields */}
          <div className="row">
            <div className="col-12 col-md-6 mb-3">
              <RequiredLabel text="Slug (Optional)" />
              <InputGroup className="mb-3" style={{ height: "47px" }}>
                <Form.Control
                  aria-label="Slug"
                  style={{ backgroundColor: "#FAFAFA" }}
                  value={slug}
                  onChange={(e) => setSlug(e.target.value)}
                  placeholder="category-url-slug"
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6 mb-3">
              <RequiredLabel text="Canonical URL (Optional)" />
              <InputGroup className="mb-3" style={{ height: "47px" }}>
                <Form.Control
                  aria-label="Canonical URL"
                  style={{ backgroundColor: "#FAFAFA" }}
                  value={canonicalUrl}
                  onChange={(e) => setCanonicalUrl(e.target.value)}
                  placeholder="https://example.com/category"
                />
              </InputGroup>
            </div>
          </div>

          <div className="col-12 mb-3">
            <RequiredLabel text="Schema (Optional)" />
            <InputGroup className="mb-3">
              <Form.Control
                as="textarea"
                rows={4}
                aria-label="Schema"
                style={{ backgroundColor: "#FAFAFA" }}
                value={setSchema}
                onChange={(e) => setSetSchema(e.target.value)}
                placeholder="Enter JSON-LD schema markup"
              />
            </InputGroup>
          </div>

          {/* Indexing Status and Media Type in one row */}
          <div className="row">
            <div className="col-12 col-md-6 mb-3">
              <RequiredLabel text="Indexing Status" />
              <Form.Select
                className="mb-3"
                value={indexingStatus}
                onChange={(e) => setIndexingStatus(e.target.value)}
                style={{ height: "47px", backgroundColor: "#FAFAFA" }}
              >
                {indexingStatusOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </div>

            <div className="col-12 col-md-6 mb-3">
              <RequiredLabel text="Media Type" />
              <Form.Select
                value={mediaType}
                onChange={(e) => {
                  const value = Number(e.target.value);
                  setMediaType(value);
                  resetMedia();
                }}
                style={{ height: "47px", backgroundColor: "#FAFAFA" }}
              >
                <option value={0}>Image</option>
                <option value={1}>Video</option>
              </Form.Select>
            </div>
          </div>

          <div className="row d-flex justify-content-between">
            <div className="col-12 col-md-5 ">
              {Number(mediaType) === 0 ? (
                <>
                  <h5 style={{ marginTop: "30px" }}>Thumbnail image </h5>{" "}
                  <p style={{ marginTop: "10px", color: "red" }}>
                    {" "}
                    Upload image in (height-300px, width-300px) .{" "}
                  </p>{" "}
                  <span></span>
                  <p style={{ color: "#8E8E93" }}>
                    ( Select your file & uploaded )
                  </p>

                  {/* Image Alt Text (only when image ID is available) */}
                  <AltTextUpdater
                    documentId={thumbId}
                    value={imageAltText}
                    onChange={setImageAltText}
                    hideInputWithoutId={true}
                  />

                  <div
                    className="w-100 browse-main d-flex align-items-center"
                    style={{
                      height: "55px",
                      border: "1px solid #E0E0E0",
                      borderRadius: "7px",
                      overflowX: "hidden",
                    }}
                  >
                    {fileName === "" ? (
                      <p className="my-2 ms-2" style={{ color: "#4F4F4F" }}>
                        No File Choosen
                      </p>
                    ) : (
                      <p className="my-2 ms-2" style={{ color: "#4F4F4F" }}>
                        {" "}
                        {fileName}
                      </p>
                    )}

                    <div className="file-up">
                      <input
                        type="file"
                        onChange={(e) => fileHandle(e)}
                        accept="image/*"
                      />
                      <p>Browse</p>
                    </div>
                  </div>
                  {URL && thumbId && (
                    <div className="my-2">
                      <img height={90} width={90} src={URL} alt="" /> <br />
                      <button
                        onClick={removeImg}
                        className="remove-btn btn btn-small mt-1  rounded"
                        style={{ border: "1px solid gray !important" }}
                      >
                        Remove
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <h5 style={{ marginTop: "30px" }}>Video </h5>{" "}
                  
                  <span></span>
                  <p style={{ color: "#8E8E93" }}>
                    ( Select your file & uploaded )
                  </p>

                  {/* Video Alt Text (only when video ID is available) */}
                  <AltTextUpdater
                    documentId={videoId}
                    value={videoAltText}
                    onChange={setVideoAltText}
                    hideInputWithoutId={true}
                  />
                  <div
                    className="w-100 browse-main d-flex align-items-center"
                    style={{
                      height: "55px",
                      border: "1px solid #E0E0E0",
                      borderRadius: "7px",
                      overflowX: "hidden",
                    }}
                  >
                    {videoName === "" ? (
                      <p className="my-2 ms-2" style={{ color: "#4F4F4F" }}>
                        No File Choosen
                      </p>
                    ) : (
                      <p className="my-2 ms-2" style={{ color: "#4F4F4F" }}>
                        {" "}
                        {videoName}
                      </p>
                    )}

                    <div className="file-up">
                      <input
                        type="file"
                        onChange={handleVideoUpload}
                        accept="video/*"
                      />
                      <p>Browse</p>
                    </div>
                  </div>
                  {videoPreview && (
                    <div className="my-2">
                      <video
                        height={120}
                        width={160}
                        src={videoPreview}
                        controls
                      />{" "}
                      <br />
                      <button
                        onClick={removeVideo}
                        className="remove-btn btn btn-small mt-1  rounded"
                        style={{ border: "1px solid gray !important" }}
                      >
                        Remove
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>

            {/* ----------status--------- */}
            <div className="col-12 col-md-5">
              <h5 style={{ marginTop: "30px" }}>Status</h5>
              <p style={{ color: "#8E8E93" }}>
                ( If the Category Option is available )
              </p>
              <div className="row mr-4">
                <div
                  className=" d-flex justify-content-between col-12 py-3"
                  style={{ backgroundColor: "#F2F2F7", borderRadius: "8px" }}
                >
                  <div className="d-flex w-100">
                    <div
                      className="d-flex py-1 justify-content-center align-items-center"
                      style={{
                        backgroundColor: "#212121",
                        width: "32px",
                        height: "32",
                        borderRadius: "3px",
                      }}
                    >
                      <img src={eye} alt="" />
                    </div>
                    <span className="mx-3">
                      {Categoryswitch ? "ON" : "OFF"}
                    </span>
                  </div>

                  <div class="form-check form-switch ">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                      width={40}
                      height={40}
                      name="category_active"
                      checked={Categoryswitch}
                      onClick={toggleSwitch}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ------------Save And Cancel------------ */}
          <div className="mt-2 mt-md-4" style={{ marginLeft: "-10px" }}>
            <button
              onClick={PostCategory}
              className=" save-btn  me-2 mt-2"
              style={{ background: "#000", color: "white" }}
            >
              Save
            </button>
            <button
              onClick={handleCancelButton}
              className="save-btn mt-2"
              style={{ border: ".4px solid #E0E0E0 !important" }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCategory;
